import Bowser from 'bowser';
const browser = Bowser.getParser(window.navigator.userAgent);

export const isWebAppSupported = () => {
  // console.log(browser.parsedResult);
  const isBrowserSupported = browser.satisfies({
    chrome: '>=73',
    chromium: '>=73',
    edge: '>=76'
  });
  return (isBrowserSupported && !isMobile());
};

export const isMobile = () => {
  const platform = browser.getPlatform();
  const type = (platform && platform.type) ? browser.getPlatform().type.toLowerCase() : null;
  return (
    type === 'mobile' || type === 'tablet' || isIpadMasqueradingAsDesktop()
  )
}

export const isSafari = () => {
  return browser.isBrowser('safari');
}

export const isChrome = () => {
  return browser.isBrowser('chrome');
}

export const openCenteredPopUp = (url, options) => {
  const popUpWidth = options.width;
  const popUpHeight = options.height;

  const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
  const winTop = window.screenTop ? window.screenTop : window.screenY;
  /*
   * window.innerWidth displays browser window's height and width excluding toolbars
   * using document.documentElement.clientWidth for IE8 and earlier
   */
  const width = window.innerWidth ||
    document.documentElement.clientWidth || document.body.clientWidth;
  const height = window.innerHeight ||
    document.documentElement.clientHeight || document.body.clientHeight;
  const left = ((width / 2) - (popUpWidth / 2)) + winLeft;
  const top = ((height / 2) - (popUpHeight / 2)) + winTop;

  const windowProps = [
    'menubar=0',
    'location=false',
    'toolbar=0',
    'personalbar=0',
    'titlebar=0',
    'status=0',
    `width=${popUpWidth}`,
    `height=${popUpHeight}`,
    `left=${left}`,
    `top=${top}`
  ].join(',');
  return window.open(
    url,
    '',
    windowProps);
}

export const isIpadMasqueradingAsDesktop = () => {
  if (!!navigator.platform && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
};

export const isWindows = () => {
  const osInfo = browser.parseOS();
  return osInfo?.name.toLocaleLowerCase() === 'windows'
}

export const isWindows81 = () => {
  const osInfo = browser.parseOS();
  return osInfo?.name.toLocaleLowerCase() === 'windows' && osInfo?.versionName === '8.1';
}

export const isCatalina = () => {
  const osInfo = browser.parseOS();
  if (osInfo?.name.toLocaleLowerCase() !== 'macos')
    return false;

  const versionInfo = osInfo?.version.split('.');
  if (versionInfo.length !== '3')
    return false;

  const satisfiesMajor = parseInt(versionInfo[0], 10) >= 10;
  const satisfiesMinor = parseInt(versionInfo[1], 10) >= 15;
  return satisfiesMajor && satisfiesMinor
}